import { Routes } from '@angular/router';

import { AppLayout } from '@layout/component/app.layout';
import { AuthGuard } from '@core/guards/auth.guard';
import { AuthChildGuard } from '@core/guards/auth-child.guard';
import { registerGuard } from '@core/guards/register.guard';
import { registerFormGuard } from '@core/guards/register-form.guard';
import { registerVerificationTokenResolver } from '@core/resolvers/register-verification-token.resolver';
import { TokenInfoResolver } from '@core/resolvers/token-info.resolver';
import { AssociateGuard } from '@core/guards/associate.guard';
import { AnonymousGuard } from '@core/guards/anonymous.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'terminos-y-condiciones',
    canMatch: [AnonymousGuard],
    loadComponent: () =>
      import('@pages/terminos-condiciones/terminos-condiciones.page').then(
        m => m.TerminosCondicionesPage
      ),
  },
  {
    path: '',
    component: AppLayout,
    canActivate: [AuthGuard],
    canActivateChild: [AuthChildGuard],
    loadChildren: () => import('./pages/pages.routes').then(m => m.PAGES_ROUTES),
  },
  {
    path: 'associate/:refCode',
    canActivate: [AssociateGuard],
    resolve: { tokenInfoAndReferral: TokenInfoResolver },
    loadComponent: () => import('@pages/associate/associate.page').then(m => m.AssociatePage),
  },
  {
    path: 'error-404',
    loadComponent: () => import('@pages/errors/error-404/error-404.page').then(m => m.Error404Page),
  },
  {
    path: 'login',
    loadComponent: () => import('@pages/auth/login/login.page').then(m => m.LoginPage),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('@pages/auth/forgot-password/forgot-password.page').then(m => m.ForgotPasswordPage),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('@pages/auth/reset-password/reset-password.page').then(m => m.ResetPasswordPage),
  },
  {
    path: 'register/code/:id',
    loadComponent: () => import('@pages/auth/register/register.page').then(m => m.RegisterPage),
  },
  {
    path: 'register',
    canActivate: [registerGuard],
    loadComponent: () => import('@pages/auth/register/register.page').then(m => m.RegisterPage),
  },
  {
    path: 'register/form',
    canActivate: [registerFormGuard],
    resolve: { tokenData: registerVerificationTokenResolver },
    loadComponent: () =>
      import('@pages/auth/register-form/register-form.page').then(m => m.RegisterFormPage),
  },
  // Post-migración (2026-08-03): las rutas del app viejo (dashboard, my-board,
  // movimientos...) no existen aquí; los marcadores/links históricos llegan con
  // esos paths vía el redirect 301 del dominio viejo. Mandarlos al home (y de
  // ahí al login si no hay sesión) en vez de a un 404 desconcertante.
  { path: '**', redirectTo: '/' },
];
